/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mvp_Sprint_Demos_Desc5Inputs */

const en_svc_mvp_sprint_demos_desc5 = /** @type {(inputs: Svc_Mvp_Sprint_Demos_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Working build in your hands every week, feedback folded in while it is cheap.`)
};

const ar_svc_mvp_sprint_demos_desc5 = /** @type {(inputs: Svc_Mvp_Sprint_Demos_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بناء يعمل بين يديك كل أسبوع، والملاحظات تدمج بينما هي رخيصة.`)
};

const bn_svc_mvp_sprint_demos_desc5 = /** @type {(inputs: Svc_Mvp_Sprint_Demos_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রতি সপ্তাহে কার্যকর বিল্ড আপনার হাতে, সস্তা থাকতেই ফিডব্যাক ঢোকানো।`)
};

const de_svc_mvp_sprint_demos_desc5 = /** @type {(inputs: Svc_Mvp_Sprint_Demos_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktionierender Build jede Woche in Ihren Händen, Feedback wird eingearbeitet, solange es günstig ist.`)
};

const es_svc_mvp_sprint_demos_desc5 = /** @type {(inputs: Svc_Mvp_Sprint_Demos_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollo funcional en sus manos cada semana, comentarios incorporados mientras sale barato.`)
};

const fr_svc_mvp_sprint_demos_desc5 = /** @type {(inputs: Svc_Mvp_Sprint_Demos_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build fonctionnel entre vos mains chaque semaine, retours intégrés pendant que ça coûte peu.`)
};

const pt_svc_mvp_sprint_demos_desc5 = /** @type {(inputs: Svc_Mvp_Sprint_Demos_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolvimento funcional nas suas mãos cada semana, comentários incorporados enquanto sai barato.`)
};

const zh_svc_mvp_sprint_demos_desc5 = /** @type {(inputs: Svc_Mvp_Sprint_Demos_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每周都有可用的构建交到你手上，趁改动还便宜时吸收反馈。`)
};

const tr_svc_mvp_sprint_demos_desc5 = /** @type {(inputs: Svc_Mvp_Sprint_Demos_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her hafta elinizde çalışan derleme, geri bildirim ucuzken işlenir.`)
};

const ru_svc_mvp_sprint_demos_desc5 = /** @type {(inputs: Svc_Mvp_Sprint_Demos_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рабочий билд в ваших руках каждую неделю, фидбек вшивается, пока это дёшево.`)
};

const pl_svc_mvp_sprint_demos_desc5 = /** @type {(inputs: Svc_Mvp_Sprint_Demos_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Działający build w rękach co tydzień, feedback wchłaniany, póki tanio.`)
};

/**
* | output |
* | --- |
* | "Working build in your hands every week, feedback folded in while it is cheap." |
*
* @param {Svc_Mvp_Sprint_Demos_Desc5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mvp_sprint_demos_desc5 = /** @type {((inputs?: Svc_Mvp_Sprint_Demos_Desc5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mvp_Sprint_Demos_Desc5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mvp_sprint_demos_desc5(inputs)
	if (locale === "bn") return bn_svc_mvp_sprint_demos_desc5(inputs)
	if (locale === "de") return de_svc_mvp_sprint_demos_desc5(inputs)
	if (locale === "es") return es_svc_mvp_sprint_demos_desc5(inputs)
	if (locale === "fr") return fr_svc_mvp_sprint_demos_desc5(inputs)
	if (locale === "pt") return pt_svc_mvp_sprint_demos_desc5(inputs)
	if (locale === "zh") return zh_svc_mvp_sprint_demos_desc5(inputs)
	if (locale === "tr") return tr_svc_mvp_sprint_demos_desc5(inputs)
	if (locale === "ru") return ru_svc_mvp_sprint_demos_desc5(inputs)
	if (locale === "pl") return pl_svc_mvp_sprint_demos_desc5(inputs)
	return en_svc_mvp_sprint_demos_desc5(inputs)
});
export { svc_mvp_sprint_demos_desc5 as "svc_mvp-sprint_DEMOS_desc" }